/**
 * Check if localStorage and sessionStorage are available and accessible
 */
export function isStorageAvailable(): boolean {
  try {
    const testKey = '__storage_test__';

    // Test localStorage
    localStorage.setItem(testKey, 'test');
    localStorage.removeItem(testKey);

    // Test sessionStorage
    sessionStorage.setItem(testKey, 'test');
    sessionStorage.removeItem(testKey);

    return true;
  } catch (e) {
    return false;
  }
}
